
<div mat-dialog-title>
  <h2>{{ (data.item[data.title] | titlecase ) || '' }}</h2>
  <button mat-dialog-close mat-mini-fab class="close">
    <mat-icon>close</mat-icon>
  </button>
  <!-- <span style="font-size: 16px;">
    {{ data.email ? data.item[data.email] : ''}}
  </span> -->
</div>

<div mat-dialog-content class="dialog-content" style="padding: 20px;">
  <div class="image-container" *ngIf="data.imageColumn">
    <img class="large-image" [src]="data.item[data.imageColumn]">
  </div>
  <div class="details-container">
    <ng-container *ngFor="let col of (data.columnas$ | async); let i = index">
    <div class="detail-item" *ngIf="col !== data.imageColumn && col !== data.title && col !== data.email && col !== data.observacion">
        <h3 class="detail-label">{{ col }} : </h3>
        <h4 class="detail-value">{{ data.item[col] }}</h4>
      </div>
    </ng-container>
  </div>
</div>
<div mat-dialog-content class="dialog-content" *ngIf="data.observacion && data.item[data.observacion]">
  <mat-form-field appearance="outline" class="notes-input">
    <mat-label>{{data.observacion}}</mat-label>
    <textarea matInput disabled [placeholder]="data.observacion">{{ data.item[data.observacion] }}</textarea>
  </mat-form-field>
</div>
<!-- <div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close cdkFocusInitial>Cerrar</button>
</div> -->
